export default class StickyHeader extends HTMLElement {
  constructor() {
    super()
    this.isOpenMobileMenu = false
    this.animationTimeOut = 300
    this.lastScrollTop = 0
    this.bannerIsInViewPort = false
    this.showHideHeaderLogo()
  }

  connectedCallback() {
    this.header = document.querySelector(".section-header-sticky")
    this.htmlElement = document.querySelector("html")
    if (!this.header) {
      return null
    }

    this.showHideHeaderLogo()
    this.setHeaderHeight()
    this.defineElements()
    this.addListeners()
  }

  showHideHeaderLogo(){
    this.imageBanner = document.querySelector("[data-logo='true']")
    this.headerLogo = this.querySelector(".header__logo")
    if (this.imageBanner){
      this.headerLogo.style.visibility = "hidden"
    }else{
      this.headerLogo.style.visibility = "visible"
    }
  }

  defineElements() {
    this.openMenuButton = this.header.querySelector(".header__menu-button-container")
    this.mobileOpenButton = this.header.querySelector(".header__menu-open-button") || null
    this.navigationItems = this.header.querySelectorAll(".header__menu-list-item:has(.header__menu-item--has-mega-menu)") || null
    this.navigationItemsSimple = this.header.querySelectorAll(".header__menu-list-item:not(:has(.header__menu-item--has-mega-menu))") || null
    this.navigationWrap = this.header.querySelector(".header__navigation") || null
  }


  setupBannerViewportObserver() {
    if (!this.imageBanner) return

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.bannerIsInViewPort = entry.isIntersecting
          if (!this.bannerIsInViewPort) {
            this.headerLogo.style.visibility = "visible"
          } else {
            this.headerLogo.style.visibility = "hidden"
          }
        })
      },
      {
        threshold: 0,
        rootMargin: "-80px 0px -80px 0px"
      }
    )
    observer.observe(this.imageBanner)
  }

  addListeners() {
    this.setupBannerViewportObserver()

    window.addEventListener("scroll",  () => {
      const currentScroll = window.scrollY
      const isScrollingUp = currentScroll < this.lastScrollTop

      if (this.imageBanner) {
        if (this.bannerIsInViewPort) {
          this.classList.add("is-transparent")
          if (currentScroll > this.lastScrollTop) {
            this.classList.add("is-hidden")
          } else if (isScrollingUp) {
            this.classList.remove("is-hidden")
          }
        } else {
          this.classList.remove("is-transparent")
          this.classList.remove("is-hidden")
        }
      } else {
        if (currentScroll <= 200) {
          this.classList.add("is-transparent")
        } else {
          this.classList.remove("is-transparent")
        }
        if (currentScroll > this.lastScrollTop) {
          this.classList.add("is-hidden")
        } else if (isScrollingUp) {
          this.classList.remove("is-hidden")
        }
      }

      this.lastScrollTop = currentScroll <= 0 ? 0 : currentScroll
    });
    
    this.openMenuButton.addEventListener("click", (event)=>{
      event.currentTarget.classList.toggle("open")
    })

    /*this.mobileOpenButton && this.mobileOpenButton.addEventListener('click', this.clickMobileMenuOpenButton.bind(this))
   
    this.navigationItems.forEach(item => {
      item.addEventListener('mouseenter', () => {
        document.querySelector(".navigation-activ")?.classList.remove('navigation-activ') 
        this.header.classList.add('hovered-navigation');
        item.classList.add('navigation-activ')
        this.navigationWrap.classList.add('submenu-activ')
      });
    });
    
    this.navigationItemsSimple.forEach(item => {
      item.addEventListener('mouseenter', () => {
        document.querySelector(".navigation-activ")?.classList.remove('navigation-activ');
        item.classList.add('navigation-activ');
        this.header.classList.remove("hovered-navigation");
      });
    });

    this.navigationWrap.addEventListener('mouseleave', () => {
      document.querySelector(".navigation-activ")?.classList.remove('navigation-activ');
      this.header.classList.remove('hovered-navigation');
    });*/
  }

  clickMobileMenuOpenButton() {
    this.isOpenMobileMenu ? this.closeMobileMenu() : this.openMobileMenu();
    this.setButtonIcon();
  }

  setButtonIcon() {
    this.mobileOpenButton.classList.toggle('open-menu-icon', !this.isOpenMobileMenu)
    this.mobileOpenButton.classList.toggle('close-menu-icon', this.isOpenMobileMenu)
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  toggleMobileMenu(show) {
    show = (show !== undefined) ? show : !this.isOpenMobileMenu
    this.isOpenMobileMenu = show
    this.isOpenMobileMenu ? this.header.setAttribute("open", "") : this.header.removeAttribute("open")
  }

  openMobileMenu() {
    this.toggleMobileMenu(true)
    this.htmlElement.classList.add('overflow-hidden');
  }

  closeMobileMenu() {
    this.toggleMobileMenu(false)
    this.htmlElement.classList.remove('overflow-hidden');
  }

}

customElements.define("sticky-header", StickyHeader)
